import {getData, putData} from './redux_data';
import {
    GET_ZONA_DETALLE, MODIFY_FIELD_DETALLE_ZONA, UPDATE_ZONA_DE_UN_CENTRO
} from '../constants/action_types';

export function getZonaDetalles(zonaId) {
    return getData('VZonaPptoDetalle/'+ zonaId, GET_ZONA_DETALLE);
};

export function modifyFieldDetalleZona(field, value) {
    return dispatch => {
        dispatch({ type: MODIFY_FIELD_DETALLE_ZONA, payload: [field, value] })
    };
};

export function updateZonaDB(zona, id) {

    // return (dispatch, getState) => {
    //     dispatch({ type: UPDATE_ZONA_DE_UN_CENTRO, payload: id })
    //     let token = getState().oidc.user ? getState().oidc.user.access_token : "";
    //     axios.put(config.API_URI() + 'VZonaPptoDetalle/' + id, zona,
    //         {
    //             headers: {
    //                 Authorization: "Bearer " + token
    //             }
    //         }
    //     ).then((response) => {
    //         dispatch({ type: UPDATE_ZONA_DE_UN_CENTRO + "_SUCCESS", payload: response })
    //         dispatch({
    //             type: OPEN_DIALOG,
    //             modalType: 'SimpleMessage',
    //             modalProps: { message: 'Cambios guardados!' },
    //             dialogid: 'success_update_zona_' + id
    //         });
    //     }).catch((error) => {
    //         if (error.response.status === 409) {

    //             dispatch({
    //                 type: OPEN_DIALOG,
    //                 modalType: 'SimpleMessage',
    //                 modalProps: { message: error.response.data.message, exception: error.response.data.ex },
    //                 dialogid: 'error_update_zona_' + id
    //             });
    //         }
    //         else {
    //             dispatch({
    //                 type: OPEN_DIALOG,
    //                 modalType: 'SimpleMessage',
    //                 modalProps: { message: error.response.data.message, exception: error.response.data.ex },
    //                 dialogid: 'error_update_zona_' + id
    //             });
    //         }
    //     });
    // }

    return putData('VZonaPptoDetalle', UPDATE_ZONA_DE_UN_CENTRO, zona, id, 'Zona guardada', undefined);

}
